@if (auth.isLoading$ | async) {
  <div class="flex max-h-full">
    <app-loading></app-loading>
  </div>
} @else {
  @if (user) {
    <section id="#scroll-section" class="bg-appBgrd flex flex-col w-screen">
      <div
        class="flex flex-col lg:flex-row w-full gap-y-1 lg:gap-8 lg:justify-start justify-end p-4 lg:p-8"
        >
        <div
          class="flex flex-col w-full justify-center items-center lg:w-4/12 lg:justify-start lg:items-end"
          >
          <div
            class="flex lg:flex-col lg:w-[310px] lg:bg-white p-4 lg:p-8 gap-6 rounded-sm lg:border-solid lg:border-gray200 lg:border-[1px] flex-wrap items-center justify-center w-full"
            >
            <h4
              class="flex flex-row items-center gap-2 lg:gap-4 text-white text-base bg-fenacoGreen p-2 rounded-3xl lg:w-full"
              >
              <mat-icon>account_circle</mat-icon>
              <span>
                {{ 'userProfile.sideMenu.menuItem1' | translate }}
              </span>
            </h4>

            <button
              class="flex flex-row text-center justify-center lg:justify-start items-center gap-2 lg:gap-4 text-base flex-wrap lg:w-full text-gray600"
              style="min-width: unset"
              id="policyBtn"
              (click)="policy()"
              >
              <mat-icon>lock</mat-icon>
              <span class="flex text-left">{{ 'navbar.policy' | translate }}</span>
            </button>

            <div
              class="hidden lg:block border-t-[1px] border-t-gray300 w-full"
            ></div>

            <button
              class="flex flex-row text-center justify-center lg:justify-start items-center gap-2 lg:gap-4 text-base flex-wrap leading-4 lg:w-full text-gray400"
              style="min-width: unset"
              id="qsLogoutBtn"
              (click)="logout()"
              >
              <mat-icon class="rotate">logout</mat-icon>
              <span class="flex text-left max-w-[186px]">{{
                'navbar.logout' | translate
              }}</span>
            </button>
          </div>
        </div>
        <div
          class="flex flex-col gap-3 w-full justify-center items-center lg:w-8/12 lg:justify-start lg:items-start"
          >
          <div
            class="flex flex-col w-full lg:w-[420px] h-fit bg-white p-8 gap-4 rounded-sm border-solid border-gray200 border-[1px]"
            >
            <div class="flex flex-col pb-2">
              <h1 class="text-gray600 text-2xl font-semibold">
                {{ 'editProfile.formTitle' | translate }}
              </h1>
              <p class="text-gray400 text-sm font-normal">
                {{ 'editProfile.formDescription' | translate }}
              </p>
            </div>

            <dl class="flex flex-col gap-4">
              <div>
                <dt class="text-gray400 text-xs">{{ 'editProfile.salutation' | translate }}</dt>
                <dd id="salutation" class="text-gray600 text-base">
                  {{ profile?.salutation ? ('editProfile.salutationOptions.' + profile.salutation | translate) : '-' }}
                </dd>
              </div>
              <div>
                <dt class="text-gray400 text-xs">{{ 'editProfile.firstName' | translate }}</dt>
                <dd id="firstName" class="text-gray600 text-base">{{ profile?.firstName || '-' }}</dd>
              </div>
              <div>
                <dt class="text-gray400 text-xs">{{ 'editProfile.lastName' | translate }}</dt>
                <dd id="lastName" class="text-gray600 text-base">{{ profile?.lastName || '-' }}</dd>
              </div>
              <div>
                <dt class="text-gray400 text-xs">{{ 'editProfile.preferredLanguage' | translate }}</dt>
                <dd id="locale" class="text-gray600 text-base">
                  {{ profile?.locale ? ('editProfile.languageOptions.' + profile.locale | translate) : '-' }}
                </dd>
              </div>
            </dl>

            <button
              id="editAccountBtn"
              type="button"
              class="filled-button !w-full !text-base"
              [ngClass]="{
                '!bg-[#009456]': isAuth0User,
                '!border-[#009456]': isAuth0User,
                '!bg-[#727573]': !isAuth0User,
                '!border-[#727573]': !isAuth0User
              }"
              [disabled]="!isAuth0User"
              (click)="editAccount()"
              >
              {{ 'account.editCta' | translate }}
            </button>

            <div class="flex flex-col gap-1 w-full pt-4">
              <p class="text-gray600 text-base font-normal">
                {{ 'editProfile.changeEmailAndPasswordSection' | translate }}
              </p>
              <div class="flex flex-row gap-2">
                <mat-icon class="formIcons">mail_outline</mat-icon>
                <div id="email" class="text-left w-full text-sm p-2 font-normal break-all">
                  {{ user.email || '••••••••' }}
                </div>
                <div class="flex flex-row gap-1 w-14 justify-center items-center">
                  <a
                    id="changeEmailLink"
                    class="text-[#334155] text-sm font-normal"
                    [class.text-gray400]="!isAuth0User"
                    [routerLink]="isAuth0User ? ['/change-email'] : null"
                    >
                    {{ 'editProfile.changeLinkCaption' | translate }}
                  </a>
                  <mat-icon class="linkIcons">open_in_new</mat-icon>
                </div>
              </div>
              <p class="text-gray600 text-base font-normal">
                {{ 'editProfile.changePassword' | translate }}
              </p>
              <div class="flex flex-row gap-2">
                <mat-icon class="formIcons">lock</mat-icon>
                <div class="text-left w-full text-base p-2 font-normal leading-7">
                  ••••••••
                </div>
                <div class="flex flex-row gap-1 w-14 justify-center items-center">
                  <button
                    id="changePasswordBtn"
                    type="button"
                    class="text-[#334155] text-sm font-normal"
                    [class.text-gray400]="!isAuth0User"
                    [disabled]="!isAuth0User"
                    (click)="changePassword()"
                    >
                    {{ 'editProfile.changeLinkCaption' | translate }}
                  </button>
                  <mat-icon class="linkIcons">open_in_new</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  }
}
